export default class PlatformFeedback{
    constructor(data){
        this.id=data?.id;
        this.rating=data?.rate;
        this.content=data?.content;
        this.createdAt=data?.created_at;
    }
}